import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toggled', 'invertToggled'];
  static values = {
    isOpen: { type: Boolean, default: false },
  };

  toggle(event) {
    event.preventDefault();
    this.isOpenValue = !this.isOpenValue;
  }

  isOpenValueChanged() {
    this.element.classList.toggle('is-toggled');
    this.toggledTargets.forEach((target) => {
      target.classList.toggle('hidden', this.isOpenValue === false);
    });
    this.invertToggledTargets.forEach((target) => {
      target.classList.toggle('hidden', this.isOpenValue !== false);
    });
  }
}
